/**
 * Detalle de una empresa (`/empresas/{companyId}`, T046).
 *
 * El sufijo `_` del nombre del archivo evita que TanStack Router anide esta pantalla dentro de
 * `_app/empresas.tsx` (que no renderiza `<Outlet/>`): es una ruta hermana, no hija.
 */
import { createFileRoute } from '@tanstack/react-router';

import { CompanyDetailPage } from '../../features/companies/company-detail-page';

function CompanyDetailRoute() {
  const { companyId } = Route.useParams();
  return <CompanyDetailPage companyId={companyId} />;
}

export const Route = createFileRoute('/_app/empresas_/$companyId')({
  component: CompanyDetailRoute,
});
